import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';

const Nav = (props) => {
    const { content } = props;

    return (
        <div className={styles.nav}>
            <div>
                {
                    content.map((item, index) => {
                        const [ sub1, sub2, sub3, sub4 ] = item.subTitle;

                        return (
                            <div className={styles.navItem} key={index}>
                                <div className={styles.mainTitle}>{item.title}</div>
                                <div className={styles.sub}>
                                    <div className={styles.subTitle}>
                                        { sub1 && <a href={sub1.url} target="_blank" rel="noreferrer">{sub1.name}</a> }
                                        { sub2 && <a href={sub2.url} target="_blank" rel="noreferrer">{sub2.name}</a> }
                                    </div>
                                    <div className={styles.subTitle}>
                                        { sub3 && <a href={sub3.url} target="_blank" rel="noreferrer">{sub3.name}</a> }
                                        { sub4 && <a href={sub4.url} target="_blank" rel="noreferrer">{sub4.name}</a> }
                                    </div>
                                </div>
                            </div>
                        );
                    })
                }
            </div>
        </div>
    );
};

Nav.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(Nav);
